<form
  class="form"
  novalidate
  (clickOutside)="onClose()"
  [attachOutsideOnClick]="true"
  (ngSubmit)="onSubmit()"
  #projectForm="ngForm"
>
  <div class="form__row form__row_column project-form__row">
    <label class="label label_style-1">Название проекта</label>
    <input
      [(ngModel)]="formState().name"
      class="input input_theme-1"
      placeholder="Введите название"
      type="text"
      required
      autofocus
      name="name"
      #nameInput
    />
  </div>

  <!--<app-select-icon class="project-form__select-icon"></app-select-icon>-->
  <app-select-color
    (onChangeColor)="onChangeColor($event)"
    [color]="formState().color"
    class="project-form__select-color"
  >
  </app-select-color>

  <div class="project-form__footer">
    <button class="button" type="button" (click)="onClose()">Отмена</button>
    <button [disabled]="projectForm.invalid || isSending()" class="button button_green">Сохранить</button>
  </div>
</form>
